import React, { useEffect, useRef, useState } from 'react';

function HiddenInput({ getProductEanCallback }: { getProductEanCallback(ean_code: string): void }) {
  const [eanCode, setEanCode] = useState<string>('');
  const eanCodeInputRef = useRef<HTMLInputElement>(null);

  const handleEanChange = (event: any) => {
    setEanCode(event.target.value);
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const copyEanCode = eanCode;
    console.log(copyEanCode);
    setEanCode('');
    getProductEanCallback(copyEanCode);
  };

  useEffect(() => {
    const loop = setInterval(() => {
      if (eanCodeInputRef.current) {
        eanCodeInputRef.current.focus();
      }
    }, 500);
    return () => clearInterval(loop);
  }, []);

  return (
    <form id="kod_kreskowy_form" onSubmit={handleSubmit}>
      <input
        ref={eanCodeInputRef}
        type="text"
        aria-autocomplete="none"
        aria-haspopup="false"
        autoCapitalize="none"
        autoComplete="off"
        autoCorrect="off"
        autoFocus
        spellCheck="false"
        title="Szukaj"
        aria-label="Szukaj"
        id="kod_kreskowy"
        style={{ position: 'absolute', top: '-500px' }}
        onChange={handleEanChange}
        value={eanCode}
      />
    </form>
  );
}
export default HiddenInput;
